export const ADDRESS_NOT_VALID_EVENT = 'cart-address-not-valid';

/**
 * send shopping cart custom event
 */
export const sendCartEvent = (eventName: string, eventDetails?: any) => {
    document.dispatchEvent(new CustomEvent(eventName, {
        detail: eventDetails,
    }));
};
